import { AutoComplete, Checkbox, Col, Form, Input, Row, Select } from 'antd';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField } from '../../../../../contextRedux/User/UserModel';
import { RootState } from '../../../../../store';
import './UserDetailsTab.css';

const { Option } = AutoComplete;

const UserDetailsTab: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const id = useSelector((state: RootState) => state?.models?.user?.id) ?? '';
  const status = useSelector((state: RootState) => state.store.userRole.data);
  const userGroups = useSelector((state: RootState) => state?.store.userGroup.data);

  const initialValues = {
    userGroupId: useSelector((state: RootState) => state?.models?.user?.userGroupId),
    email: useSelector((state: RootState) => state?.models?.user?.email),
    name: useSelector((state: RootState) => state?.models?.user?.name),
    password: useSelector((state: RootState) => state?.models?.user?.password),
    isActive: useSelector((state: RootState) => state?.models?.user?.isActive),
    subdomain: useSelector((state: RootState) => state?.models?.user?.subdomain),
    signature: useSelector((state: RootState) => state?.models?.user?.signature),
    userPermission: useSelector((state: RootState) => state?.models?.user?.userPermission),
    userGroup: useSelector((state: RootState) => state?.models?.user?.userGroup),
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const handleSelectUserGroup = (value: any): void => {
    const userGroupSelected: any = userGroups?.find((group: any) => group?.name === value);

    const newUserGroup = {
      id: userGroupSelected?.id,
      name: userGroupSelected?.name,
      isActive: userGroupSelected?.isActive,
    };

    form.setFieldsValue({
      userGroupId: userGroupSelected?.id ?? '',
      userGroup: newUserGroup,
    });

    dispatch(updateField({ field: 'userGroupId', value: newUserGroup?.id ?? null }));
    dispatch(updateField({ field: 'userGroup', value: newUserGroup ?? null }));
  };

  const handleCheckboxChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const fieldsValue = {
        ...form.getFieldsValue(true),
        isActive: e.target.checked,
      };
      form.setFieldsValue(fieldsValue);

      dispatch(updateField({ field: 'isActive', value: e.target.checked ?? false }));
    },
    [form]
  );

  return (
    <Form
      form={form}
      name='userForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      layout='vertical'
      className='userDetailsTab'
    >
      <Row gutter={[16, 16]} className='row'>
        <Col xs={24} sm={12}>
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
          <Form.Item label='Email' name='email' rules={[{ required: true, message: 'Introdu email!' }]}>
            <Input />
          </Form.Item>
          {!id && (
            <Form.Item label='Parola' name='password' rules={[{ required: true, message: 'Introdu parola!' }]}>
              <Input.Password />
            </Form.Item>
          )}
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            label='Permisiune'
            name={['userPermission', 'rols']}
            rules={[{ required: true, message: 'Introdu permisiune!' }]}
          >
            <Select mode='multiple'>
              {status?.map((item, index) => (
                <Option key={index} value={item?.name}>
                  {item?.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item label='Group' name={['userGroup', 'name']}>
            <AutoComplete
              onSelect={(value) => handleSelectUserGroup(value)}
              onChange={(value) => handleSelectUserGroup(value)}
              allowClear
            >
              {userGroups?.map((item, index) => (
                <Option key={index} value={item?.name}>
                  {item?.name}
                </Option>
              ))}
            </AutoComplete>
          </Form.Item>
          <Form.Item label='Status' name='isActive' valuePropName='checked'>
            <Checkbox onChange={() => handleCheckboxChange} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default UserDetailsTab;
